import { UIKnightPlacementHoverActionController } from '../ui_game_hover_actions/UIKnightPlacementHoverActionController.ts';
import { UIKnightActivationHoverActionController } from '../ui_game_hover_actions/UIKnightActivationHoverActionController.ts';
import { UIKnightUpgradeHoverActionController } from '../ui_game_hover_actions/UIKnightUpgradeHoverActionController.ts';
import { UIKnightActionHoverActionController } from '../ui_game_hover_actions/UIKnightActionHoverActionController.ts';
import { MechanicValidatorKnight, MechanicValidatorKnightActions } from '@colonist/game-mechanic-validators';
export class UIGameKnightController {
    initializeHoverActions() {
        if (this.uiGameManager.gameController.isPlayerSpectator) return;
        if (this.uiGameManager.gameController.isReplay) return;
        const myKnightValidator = this.knightValidator.getKnightPlayerValidator(this.uiGameManager.gameController.myColor);
        new UIKnightPlacementHoverActionController(this.uiGameManager, myKnightValidator);
        new UIKnightUpgradeHoverActionController(this.uiGameManager, myKnightValidator);
        new UIKnightActivationHoverActionController(this.uiGameManager, myKnightValidator);
        new UIKnightActionHoverActionController(this.uiGameManager, this.knightActionValidator);
    }
    constructor(uiGameManager, knightState, robberState, pirateState){
        this.uiGameManager = uiGameManager;
        this.knightValidator = new MechanicValidatorKnight(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, knightState);
        this.knightActionValidator = new MechanicValidatorKnightActions(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, knightState, robberState, pirateState);
        this.initializeHoverActions();
    }
}
